import orderBy from 'lodash/orderBy';
import { attr, fk, many } from 'redux-orm';

import BaseModel from './BaseModel';
import ActionTypes from '../constants/ActionTypes';

import User from './User';
import Label from './Label';

export default class extends BaseModel {
  static modelName = 'Board';

  static fields = {
    id: attr(),
    position: attr(),
    name: attr(),
    isPublic: attr(),
    isFetching: attr({
      getDefault: () => null,
    }),
    includeCardsWithoutMembers: attr({
      getDefault: () => false,
    }),
    includeCardsWithoutLabels: attr({
      getDefault: () => false,
    }),
    projectId: fk({
      to: 'Project',
      as: 'project',
      relatedName: 'boards',
    }),
    permissions: attr(),
    filterUsers: many('User', 'filterBoards'),
    filterLabels: many('Label', 'filterBoards'),
    filterText: attr({
      getDefault: () => '',
    }),
    // ─── NOUVEAU : délai avant masquage (heures) ───
    hideDoneAfter: attr({
      getDefault: () => null,
    }),
    // ─── NOUVEAU : colonne "terminé" ───
    doneListId: fk({
      to: 'List',
      as: 'doneList',
      relatedName: 'doneForBoards',
      getDefault: () => null,
    }),
  };

  static reducer({ type, payload }, Board) {
    switch (type) {
      case ActionTypes.LOCATION_CHANGE_HANDLE:
        console.log('LOCATION_CHANGE_HANDLE PAYLOAD');
        console.log(payload);

        if (payload.board) {
          console.log('BOARD UPSERT DATA');
          console.log({
            ...payload.board,
            permissions: payload.permissions || [],
            isFetching: false,
          });

          Board.upsert({
            ...payload.board,
            permissions: payload.permissions || [],
            isFetching: false,
          });
        }

        break;
      case ActionTypes.LOCATION_CHANGE_HANDLE__BOARD_FETCH:
      case ActionTypes.BOARD_FETCH: {
        const boardModel = Board.withId(payload.id);
        if (boardModel) {
          boardModel.update({ isFetching: true });
        }

        break;
      }
      case ActionTypes.SOCKET_RECONNECT_HANDLE:
        Board.all().delete();

        if (payload.board) {
          Board.upsert({
            ...payload.board,
            isFetching: false,
          });
        }

        payload.boards.forEach((board) => {
          Board.upsert(board);
        });

        break;
      case ActionTypes.SOCKET_RECONNECT_HANDLE__CORE_FETCH:
        Board.all()
          .toModelArray()
          .forEach((boardModel) => {
            // console.log('BOARD ID CHECK', {
            //   boardModelId: boardModel.id,
            //   boardModelIdType: typeof boardModel.id,

            //   currentBoardId: payload.currentBoardId,
            //   currentBoardIdType: typeof payload.currentBoardId,
            // });
            if (boardModel.id !== payload.currentBoardId) {
              boardModel.update({
                isFetching: null,
              });

              boardModel.deleteRelated(payload.currentUserId);
            }
          });

        break;
      case ActionTypes.CORE_INITIALIZE:
        console.log('CORE INITALIZEDFHFEDIU');
        console.log(payload);
        if (payload.board) {
          console.log('CORE INITIALIZE PERMISSIONS');
          console.log(payload.permissions);
          Board.upsert({
            ...payload.board,
            permissions: payload.permissions || [],
            isFetching: false,
          });
        }

        payload.boards.forEach((board) => {
          Board.upsert(board);
        });

        break;
      case ActionTypes.USER_TO_BOARD_FILTER_ADD:
        if (payload.id === null) {
          Board.withId(payload.boardId).update({ includeCardsWithoutMembers: true });
        } else {
          Board.withId(payload.boardId).filterUsers.add(payload.id);
        }

        break;
      case ActionTypes.USER_FROM_BOARD_FILTER_REMOVE:
        if (payload.id === null) {
          Board.withId(payload.boardId).update({ includeCardsWithoutMembers: false });
        } else {
          Board.withId(payload.boardId).filterUsers.remove(payload.id);
        }

        break;
      case ActionTypes.PROJECT_CREATE_HANDLE:
        payload.boards.forEach((board) => {
          Board.upsert(board);
        });

        break;
      case ActionTypes.PROJECT_MANAGER_CREATE_HANDLE:
      case ActionTypes.BOARD_MEMBERSHIP_CREATE_HANDLE:
        if (payload.boards) {
          payload.boards.forEach((board) => {
            Board.upsert({
              ...board,
              ...(payload.board &&
                payload.board.id === board.id && {
                  isFetching: false,
                }),
            });
          });
        }

        break;
      case ActionTypes.BOARD_DUPLICATE__SUCCESS:
      case ActionTypes.BOARD_DUPLICATE_HANDLE:
        Board.upsert(payload.board);

        break;
      case ActionTypes.BOARD_CREATE:
      case ActionTypes.BOARD_CREATE_HANDLE:
      case ActionTypes.BOARD_UPDATE__SUCCESS:
      case ActionTypes.BOARD_UPDATE_HANDLE:
        Board.upsert(payload.board);

        break;
      case ActionTypes.BOARD_CREATE__SUCCESS:
        Board.withId(payload.localId).delete();
        Board.upsert(payload.board);

        break;
      case ActionTypes.BOARD_FETCH__SUCCESS:
        Board.upsert({
          ...payload.board,
          isFetching: false,
        });

        break;
      case ActionTypes.BOARD_FETCH__FAILURE:
        Board.withId(payload.id).update({
          isFetching: null,
        });

        break;
      case ActionTypes.BOARD_UPDATE:
        Board.withId(payload.id).update(payload.data);

        break;
      case ActionTypes.BOARD_DELETE:
        Board.withId(payload.id).deleteWithRelated();

        break;
      case ActionTypes.BOARD_DELETE__SUCCESS:
      case ActionTypes.BOARD_DELETE_HANDLE: {
        const boardModel = Board.withId(payload.board.id);

        if (boardModel) {
          boardModel.deleteWithRelated();
        }

        break;
      }
      case ActionTypes.LABEL_TO_BOARD_FILTER_ADD:
        if (payload.id === null) {
          Board.withId(payload.boardId).update({ includeCardsWithoutLabels: true });
        } else {
          Board.withId(payload.boardId).filterLabels.add(payload.id);
        }

        break;
      case ActionTypes.LABEL_FROM_BOARD_FILTER_REMOVE:
        if (payload.id === null) {
          Board.withId(payload.boardId).update({ includeCardsWithoutLabels: false });
        } else {
          Board.withId(payload.boardId).filterLabels.remove(payload.id);
        }

        break;
      case ActionTypes.TEXT_FILTER_IN_CURRENT_BOARD: {
        const board = Board.withId(payload.boardId);
        let filterText = payload.text;
        const posSpace = filterText.indexOf(' ');

        // Shortcut to user filters
        const posAT = filterText.indexOf('@');
        if (posAT >= 0 && posSpace > 0 && posAT < posSpace) {
          const userId = User.findUsersFromText(
            filterText.substring(posAT + 1, posSpace),
            board.memberships.toModelArray().map((membership) => membership.user),
          );
          if (
            userId &&
            board.filterUsers.toModelArray().filter((user) => user.id === userId).length === 0
          ) {
            board.filterUsers.add(userId);
            filterText = filterText.substring(0, posAT);
          }
        }

        // Shortcut to label filters
        const posSharp = filterText.indexOf('#');
        if (posSharp >= 0 && posSpace > 0 && posSharp < posSpace) {
          const labelId = Label.findLabelsFromText(
            filterText.substring(posSharp + 1, posSpace),
            board.labels.toModelArray(),
          );
          if (
            labelId &&
            board.filterLabels.toModelArray().filter((label) => label.id === labelId).length === 0
          ) {
            board.filterLabels.add(labelId);
            filterText = filterText.substring(0, posSharp);
          }
        }

        board.update({ filterText });

        break;
      }
      default:
    }
  }

  getOrderedLabelsQuerySet() {
    return this.labels.orderBy('position');
  }

  getOrderedListsQuerySet() {
    return this.lists.orderBy('position');
  }

  deleteRelated(exceptMemberUserId) {
    this.memberships.toModelArray().forEach((boardMembershipModel) => {
      if (boardMembershipModel.userId !== exceptMemberUserId) {
        boardMembershipModel.deleteWithRelated();
      }
    });

    this.labels.delete();

    this.lists.toModelArray().forEach((listModel) => {
      listModel.deleteWithRelated();
    });
  }

  deleteWithRelated() {
    this.deleteRelated();
    this.delete();
  }
}
